import React from 'react'
import CMSForm from './CMSForm'

const AddCmsForm = () => {
  return (
    <React.Fragment>
      <CMSForm title="Terms and Privacy" addCmsLink={true} />
    </React.Fragment>
  )
}

export default AddCmsForm
